export const init = () => {
  jQuery(function($) {
      // セッションで1度だけ表示
      if ( $("#layer_board_area").length > 0 && sessionStorage.getItem('fvTop') === null) {
          $('#layer_board_area').layerBoard({
              delayTime: 0,
              fadeTime : 300,
              alpha : 0.5,
              limitMin : 5,
              easing: 'swing',
              limitCookie : 0
          });
          sessionStorage.setItem('fvTop', 'visited');
      }

  })
};
export default init;
